import { lazy, useState, useEffect, Suspense } from 'react'
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import ScrollToTop from './components/ScrollTop';
import GTMTracker from './components/GTMTracker';

const Home = lazy(() => import("./views/home/home"));
const PublicTermsConditions = lazy(() => import("./views/APP-LP-TermsConditions/PublicTermsConditions"));
const PublicPrivacyPolicy = lazy(() => import("./views/APP-LP-PrivacyPolicy/PublicPrivacyPolicy"));
const PublicAboutUs = lazy(() => import("./views/APP-LP-AboutUs/PublicAboutUs"));
const PublicContactUs = lazy(() => import("./views/APP-LP-ContactUs/PublicContactUs"));

const loading = (
  <div className="text-center mt-5 mb-5">
    {/*<div className="spinner-border" role="status">
        <span className="visually-hidden"></span>
    </div>*/}
  </div>
)


function App() {

  const { i18n } = useTranslation()

  const[ language, setLanguage] = useState(i18n?.language || 'en')

  useEffect(() => {
    if(language){
      i18n.changeLanguage(language)
    }
  },[language])

  return (
    <HelmetProvider>
      <Suspense fallback={loading}>
        <Router>
          <GTMTracker />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home language={language} setLanguage={setLanguage} />} />
            <Route path="/termsconditions" element={<PublicTermsConditions language={language} setLanguage={setLanguage} />} />
            <Route path="/privacypolicy" element={<PublicPrivacyPolicy language={language} setLanguage={setLanguage} />} />
            <Route path="/aboutus" element={<PublicAboutUs language={language} setLanguage={setLanguage} />} />
            <Route path="/contactus" element={<PublicContactUs language={language} setLanguage={setLanguage} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </Suspense>
    </HelmetProvider>
  );
}

export default App;
